import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import {
  TranslateClient,
  TranslateTextCommand,
} from '@aws-sdk/client-translate';
import useSWR from 'swr';
import config from '../config';

async function translate([sourceText, destLang, srcLang]) {
  if (sourceText.length === 0) {
    return '';
  }
  const client = new TranslateClient({
    region: 'eu-west-1',
    credentials: config.awsTranslateCredentials,
  });

  const params = {
    SourceLanguageCode: srcLang,
    TargetLanguageCode: destLang,
    Text: sourceText,
  };

  const command = new TranslateTextCommand(params);
  try {
    const data = await client.send(command);
    return data.TranslatedText;
  } catch (err) {
    console.error('failed to translate', err);
    return sourceText;
  }
}

function TranslationField({
  srcLang,
  destLang,
  value,
  srcText,
  label,
  onChange,
  ...fields
}) {
  const [val, setVal] = useState(value);
  const [inText, setInText] = useState(srcText);
  const { data } = useSWR([inText, destLang, srcLang], translate);

  useEffect(() => {
    setVal(data);
    onChange(data);
  }, [data]);

  const handleAutotranslate = () => {
    setInText(srcText);
  };

  const handleChange = (e) => {
    setVal(e.target.value);
    onChange(e.target.value);
  };

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <TextField
      {...fields}
      label={label}
      value={val}
      onChange={handleChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label='translate text'
              onClick={handleAutotranslate}
              edge='end'
            >
              <TranslateIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

TranslationField.propTypes = {
  srcLang: PropTypes.string.isRequired,
  destLang: PropTypes.string.isRequired,
  srcText: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

TranslationField.defaultProps = {
  srcText: '',
  value: '',
  onChange: () => {},
};

export default TranslationField;
